import { useGetRequest } from "hooks/utils/useGetRequest";
import { CreatedInterfaces } from "interfaces";

const resource = 'claim-detail';

const useGetClaimDetail = (id: string) => {

  const [{ data, error, loading }, fetchClaim]= useGetRequest<CreatedInterfaces<typeof resource>>({
    path: `v1/claims/${id}`
  });

  return {
    claim: data,
    isLoading: loading,
    isError: error,
    refetchClaim: fetchClaim
  };
};

export default useGetClaimDetail;
  